import React from 'react';
import { Link } from 'react-router-dom';
import { FiHome } from 'react-icons/fi';

const NotFound = () => {
    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-50">
            <div className="text-center p-8">
                <div className="text-8xl font-bold text-blue-600 mb-4">404</div>
                <h1 className="text-2xl font-bold text-gray-800 mb-2">Page Not Found</h1>
                <p className="text-gray-500 mb-6">पान सापडले नाही / The page you're looking for doesn't exist.</p>
                <Link
                    to="/dashboard"
                    className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                >
                    <FiHome />
                    Go to Dashboard
                </Link>
            </div>
        </div>
    );
};

export default NotFound;